import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import MenuItem from '@mui/material/MenuItem';

import logo from "../LogoFont.png";
import { Divider, Drawer } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Langue from './Langue';
import Mode from './Mode';
import GetCookie from '../Services/GetCookie';
import Data from "../Data/.json"

const drawerWidth = 240;

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const navigate = useNavigate()
  const { t } = useTranslation();
  const pages = [t("accueil") + '|/', t("apropos") + '|/about', t("services") + '|/services', t("projets") + "|/projects", t("contactM") + "|/contact", t("carriere") + "|/career"];


  const cookieMode = GetCookie(Data.mode);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = (link: string) => {
    navigate(link)
    setAnchorElNav(null);
  };


  return (
    <AppBar position="fixed" variant='outlined' style={{ height: "90px", background: cookieMode === 'dark' ? "rgba(0, 0, 0, 1)" : cookieMode === 'light' ? 'white' : "white" }}>
      <Container maxWidth="lg" >
        <Toolbar disableGutters>
          <Box width={120} sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} className='anim-img'>
            <Link to={"/"}> <img className='img-pro' style={{ borderRadius: "100%" }} src={logo} width={20} alt="" /></Link>
          </Box>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >

          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon color='primary' />
            </IconButton>
          </Box>
          <Box gap={1} sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }}>
            <Box width={120} className='anim-img'>
              <Link to={"/"}> <img className='img-pro' style={{ borderRadius: "100%" }} src={logo} width={20} alt="" /></Link>
            </Box>
            <Box sx={{ flexGrow: 0 }} className='action' >
              <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>

                <hr />
                <Mode />
                <hr />
                <Langue />
              </Box>
            </Box>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >

          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>

          </Box>

          <Box sx={{ flexGrow: 0 }} className='action' >
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
              {pages.map((page) => (
                <button
                  style={{ color: cookieMode === "dark" ? "white" : cookieMode === "light" ? "#293038" : "black", width: "85px" }}
                  className='btn-menu'
                  key={page.split('|')[0]}
                  onClick={() => { handleCloseNavMenu(page.split('|')[1]) }}
                // sx={{ my: 2, color: 'white', display: 'block' }}
                >
                  {page.split('|')[0]}
                </button>
              ))}
              <hr />

              <Mode />
              <hr />
              <Langue />
            </Box>


            <nav >
              <Drawer

                variant="temporary"
                open={Boolean(anchorElNav)}
                onClose={() => { setAnchorElNav(null) }}
                ModalProps={{
                  keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                  display: { xs: 'block', sm: 'none' },
                  '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
              >
                <Box height={"100%"} style={{ backgroundColor: (cookieMode === "dark") ? "#101316" : (cookieMode === "light") ? "white" : "inherit", color: (cookieMode === "dark") ? "white" : (cookieMode === "light") ? "black" : "inherit" }}>
                  <center>
                    <Box width={120} className='anim-img'>
                      <Link to={"/"}> <img className='img-pro' style={{ borderRadius: "100%" }} src={logo} width={20} alt="" /></Link>
                    </Box>
                  </center>
                  <Divider />
                  {pages.map((page) => (
                    <MenuItem key={page} onClick={() => { handleCloseNavMenu(page.split('|')[1]) }}>
                      <Typography textAlign="center">{page.split('|')[0]}</Typography>
                    </MenuItem>
                  ))}
                  <Divider /><br />
                  {/* <center style={{ width: "100%", fontSize: "small" }} className='textgray'> <Footer /> </center> */}
                </Box>

              </Drawer>
            </nav>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;